module.exports = __webpack_public_path__ + "static/media/logo.760e876e.png";